<template>
  <div>
    <vx-card
      v-for="tr in courseRegistrations"
      :key="tr.ID"
      card-background="#ebf7ff"
      class="mt-5"
      content-color="#fff"
    >
      <div class="vx-row">
        <div class="vx-col lg:w-1/6 justify-center">
          <img :src="baseUrl + tr.Status.ImagePath" alt="" class="w-full" />
        </div>
        <div class="vx-col lg:w-1/4">
          <img alt="" class="ml-5" src="@/assets/images/education.svg" />
          <div class="lg:w-2/3 ml-2">
            <h4 style="" v-if="tr.Course">{{ tr.Course.Name }}</h4>
            <h4 style="" v-if="!tr.Course">{{ tr.CourseName }}</h4>
            <div class="mt-5" style="color: #ada8a8">{{$t('StartDate')}}</div>
              <p style="color: #5e5e5e">
                {{ tr.CourseStartDate.split("T")[0] }}
              </p>
              <p class="mt-5" style="color: #ada8a8">{{$t('Status')}}</p>
              <p style="color: #5e5e5e">{{ tr.Status.Name }}</p>
          </div>
        </div>
        <div class="vx-col lg:w-2/5" style="color: black">
              <div v-if="tr.Status.ID==1||tr.Status.ID==2||tr.Status.ID==8">
                  {{tr.Status.Description}}
              </div>

            <div v-if="tr.Status.ID==3">
                <div v-if="tr.RegistrationGeneralExams.length==0
                     ||!tr.RegistrationGeneralExams[0].Result">
                     {{tr.Status.Description}}
                </div>
                <div v-else>
                    {{$t('YourAddmissionTestDegree')}}: {{tr.RegistrationGeneralExams[0].Result.toFixed(2)}}
                </div>
            </div>
            <div v-if="tr.Status.ID==4">
                  <div v-if="tr.PaymentTypeID== 2 && tr.InvoiceDetails.length >0 && !tr.InvoiceDetails[0].ConfirmPayAttachement">
                        <h6 style="color:orange">{{$t('PaymentSwiftCheck')}}</h6>
                        <vs-upload   automatic :limit="1" :action="uploadUrl+'?id='+tr.ID" :headers="UploadRequestHeader"  @on-success="successUploadPayProof" />
                  </div>
                  <div v-if="tr.PaymentTypeID==2 && tr.InvoiceDetails.length>0 && tr.InvoiceDetails[0].ConfirmPayAttachement">
                     {{$t('ThanksForPayment')}}
                  </div>
                  <div v-else>
                      {{tr.Status.Description}}
                  </div>
            </div>

            <div v-if="tr.Status.ID==7">
                 <div v-if="tr.IsVisaRequired && !tr.TravelDataFilled">
                   <vs-input  v-model="tr.NameASPassport" :label="$t('NameAsPassport')" class="w-full"></vs-input>
                   <vs-input v-model="tr.PassportNo" :label="$t('PassportNumber')" class="w-full"></vs-input>
                   <h6 class="mt-5" style="color:orange">{{$t('PassportAttachment')}}</h6>
                   <vs-upload  automatic :limit="1" :action="uploadUrl+'?id='+tr.ID" :headers="UploadRequestHeader"  @on-success="successUploadPassport" />
                   <vs-checkbox v-if="tr.IsVisaOnArrival" v-model="tr.VisaOnArrival">{{$t('VisaOnArrival')}}</vs-checkbox>
                 </div>

                 <div v-if="tr.IsVisaRequired && tr.TravelDataFilled && !tr.VisaProof && !tr.VisaOnArrival">
                     <h6 class="mt-5" style="color:orange">{{$t('VisaProofAttachment')}}t</h6>
                     <vs-upload  automatic  :limit="1" :action="uploadUrl+'?id='+tr.ID" :headers="UploadRequestHeader"  @on-success="successUploadVisaProof" />
                 </div>
                 <div v-if="tr.IsVisaRequired && tr.TravelDataFilled && !tr.FlightTicket">
                     <h6 class="mt-5" style="color:orange">{{$t('FlightTicketAttachment')}}</h6>
                     <vs-upload  automatic  :limit="1" :action="uploadUrl+'?id='+tr.ID" :headers="UploadRequestHeader"  @on-success="successUploadFlightTicket" />
                 </div>
               <div v-if="!tr.IsVisaRequired  && !tr.FlightTicket">
                     <h6 class="mt-5" style="color:orange">{{$t('FlightTicketAttachment')}}</h6>
                     <vs-upload  automatic  :limit="1" :action="uploadUrl+'?id='+tr.ID" :headers="UploadRequestHeader"  @on-success="successUploadFlightTicket" />
                 </div>

                 <div v-if="tr.IsVisaRequired && tr.TravelDataFilled && tr.VisaProof">
                     {{$t('PleaseProv')}}
                 </div>

                  <div v-if="!tr.IsVisaRequired  && tr.AccumodationFilled">
                       {{$t('PleaseProvReg')}}
                  </div>

                 <div v-if="!tr.AccumodationFilled">
                    <vs-checkbox v-model="tr.IsAccommodation">{{$t('WithAccommodation')}}</vs-checkbox>
                    <div v-if="tr.IsAccommodation" class="mt-2" >
                        <p>{{$t('RoomType')}}</p>
                        <v-select
                            label="Name"
                            class=" w-full"
                            autocomplete
                            v-model="tr.RoomType"
                            :options="RoomTypes"
                            :reduce="Name => Name.Name"
                        />
                    </div>
                 </div>
            </div>
        </div>
        <div class="vx-col lg:w-1/6 margin-auto" v-if="(tr.IsVisaRequired && !tr.TravelDataFilled )&&tr.Status.ID!=4&&tr.Status.ID!=3&&tr.Status.ID!=1&&tr.Status.ID!=2&&tr.Status.ID!=8">
           <vs-button :disabled="!(tr.NameASPassport&&tr.PassportNo&&passportUploaded)" color="#3D7299" type="filled" @click="SaveRegistration(tr)">{{$t('Submit')}}</vs-button>
        </div>
      </div>
    </vx-card>
  </div>
</template>
<script>
import vSelect from 'vue-select'
import moduleCourseRegistration from "@/store/courseRegistration/moduleCourseRegistration.js";
import { domain, mainSetting } from "@/gloabelConstant.js";
export default {
  components:{
    vSelect
  },
  data() {
    return {
      UploadRequestHeader:mainSetting.UploadRequestHeader,
       uploadUrl: domain + "API/Course/UploadFile",
      baseUrl: domain,
      CourseRegistrationModel: {},
       passportUploaded:false,
      RoomTypes:[
        {ID:1,Name:"Single  50 USD",Price:""},
        {ID:2,Name:"Double 40 USD",Price:""},
        {ID:2,Name:"Triple 30 USD",Price:""}
      ]
    };
  },
  methods: {

    SaveRegistration(data) {
      this.CourseRegistrationModel = data;

      this.CourseRegistrationModel.IsSendMail = true;

       if(! this.CourseRegistrationModel.IsAccommodation)
          this.CourseRegistrationModel.IsAccommodation=false;
      var vm=this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (
            this.CourseRegistrationModel.ID !== null &&
            this.CourseRegistrationModel.ID >= 0
          ) {
            this.$vs.loading();
            this.$store
              .dispatch(
                "courseRegistrationList/updateItem",
                this.CourseRegistrationModel
              )
              .then((res) => {
                debugger
                document.getElementsByClassName("btn-x-file")[0].click();
                data.TravelDataFilled  =res.data.PassportNo
                data.AccumodationFilled = res.data.AccumodationFilled
                vm.$vs.loading.close();

                 vm.$vs.notify({
                      color: "success",
                      title: "Save success",
                      text: "Your Operation done successfully",
                    });
                 vm.$store.dispatch(
                     "courseRegistrationList/GetCourseRegistrationsByTraineeID"
                );
              })
              .catch((error) => {
                this.$vs.loading.close();
              });
          } else {
            this.$vs.loading();
            this.$store
              .dispatch(
                "courseRegistrationList/addItem",
                this.CourseRegistrationModel
              )
              .then(() => {
                this.$vs.loading.close();
              })
              .catch((error) => {
                this.$vs.loading.close();
              });

            this.$router.push("/CourseRegistration");
          }
        }
      });
    },

    successUploadPassport(event) {
      debugger
      var obj = {};
      obj.ID = event.target.responseText.split('_')[1];
      obj.PassportPath = event.target.responseText.split('_')[0];
      this.$store.dispatch("courseRegistrationList/SaveTraineePassport", obj).then(res=>{
        this.passportUploaded=true;
        this.$vs.notify({
          color: "success",
          title: "Upload Success",
         text: this.$t("SuccessuploadyourAttachment")
        });
      });
    },

    successUploadPayProof(event) {
      debugger
      var obj = {};
      obj.CourseRegistrationID = event.target.responseText.split('_')[1];
      obj.ConfirmPayAttachement = event.target.responseText.split('_')[0];
      this.$store.dispatch("courseRegistrationList/SavePaymentProof", obj).then(res => {
          this.$store.dispatch(
                "courseRegistrationList/GetCourseRegistrationsByTraineeID"
              );
      });
      this.$vs.notify({
        color: "success",
        title: "Upload Success",
        text: this.$t("SuccessuploadyourAttachment")
      });
    },

    successUploadVisaProof(event) {
      var obj = {};
      obj.ID = event.target.responseText.split('_')[1];
      obj.VisaProof = event.target.responseText.split('_')[0];
      this.$store.dispatch("courseRegistrationList/SaveVisaProof", obj).then(res=>{
         this.$store.dispatch(
                "courseRegistrationList/GetCourseRegistrationsByTraineeID"
              );
      });
      this.$vs.notify({
        color: "success",
        title: "Upload Success",
        text: this.$t("SuccessuploadyourAttachment")
      });
    },

    successUploadFlightTicket(event)
    {
      var obj = {};
        obj.ID = event.target.responseText.split('_')[1];
        obj.FlightTicket = event.target.responseText.split('_')[0];
        this.$store.dispatch("courseRegistrationList/SaveFlightTicket", obj).then(res=>{
          this.$store.dispatch(
                  "courseRegistrationList/GetCourseRegistrationsByTraineeID"
                );
        });
        this.$vs.notify({
          color: "success",
          title: "Upload Success",
        text: this.$t("SuccessuploadyourAttachment")
        });
    }

  },
  computed: {
    courseRegistrations() {
      return this.$store.state.courseRegistrationList.courseRegistrations;
    },
  },
  created() {
    if (!moduleCourseRegistration.isRegistered) {
      this.$store.registerModule(
        "courseRegistrationList",
        moduleCourseRegistration
      );
      moduleCourseRegistration.isRegistered = true;
    }
    this.$store.dispatch(
      "courseRegistrationList/GetCourseRegistrationsByTraineeID"
    );
  },
};
</script>
<style>
 .con-img-upload
 {
     background: transparent!important;;
 }
</style>
